import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';

export default function AuthShell({ children, subtitle }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Paper sx={{ p: { xs: 3, sm: 4 }, width: '100%', maxWidth: 440 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(99,102,241,0.4)',
              flexShrink: 0,
            }}
          >
            <Typography sx={{ color: '#fff', fontWeight: 800, fontSize: '1rem', fontFamily: '"DM Sans", sans-serif' }}>
              B
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontWeight: 700, fontSize: '1.05rem', lineHeight: 1.2 }}>
              Bernardo PO Parser
            </Typography>
            <Typography sx={{ fontSize: '0.75rem', color: isDark ? 'rgba(148,163,184,0.75)' : 'text.secondary' }}>
              {subtitle || 'Sign in with Bernardo SSO'}
            </Typography>
          </Box>
        </Box>
        {children}
      </Paper>
    </Box>
  );
}